import React from 'react'
import { getGatsbyImageData, srcSizes } from '../common/gatsbyImageData'
import IconLoaders from '../icons/IconLoaders'

export const getImageMeta = (image) => {
  let imageMeta = null
  // #1 - it's gatsby graphql queried item
  if (image?.gatsbyImageDataMock) {
    imageMeta = image.gatsbyImageDataMock
    // #2 - it's gatsby graphql queried item
  } else if(image.url && image.width && image.height && image.ext) {
    imageMeta = image
  }
  return imageMeta
}
const useCDNImage = (image, product, srcSetSizes=srcSizes, sizes='100vw') => {
  return React.useMemo(() => {
    if(!image) return image
    if (image?.gatsbyImageData) return image
    const imageMeta = getImageMeta(image)
    if(!imageMeta) return image
    const { width, height, url, ext } = imageMeta
    const item = { ...image }
    item.gatsbyImageData = getGatsbyImageData({ width, height, url, ext }, srcSetSizes, sizes)
    item.gatsbyImageData.placeholder = {
      children: <IconLoaders type={product?.productType} />,
      className: 'm-1',
    }
    return item
  }, [image, srcSetSizes, sizes, product?.productType])
}

export default useCDNImage
